"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const gatsby_theme_leshen_1 = require("@leshen/gatsby-theme-leshen");
const mapToButtonProps_1 = __importDefault(require("./mapToButtonProps"));
const mapToPhoneNumberProps_1 = __importDefault(require("./mapToPhoneNumberProps"));
function mapHeaderCtaButtons(buttons, mappers) {
    const components = [];
    for (let i = 0; i < buttons.length; i++) {
        const btn = buttons[i];
        if (!btn.id || !btn.cta?.length) {
            console.warn('unable to render cta button: has missing data');
            continue;
        }
        const cta = btn.cta[0];
        if (cta.relationTo === 'buttons' && typeof cta.value === 'object') {
            components.push((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.LinkButton, { ...(0, mapToButtonProps_1.default)({ data: cta.value, mappers }) }, btn.id));
        }
        else if (cta.relationTo === 'phoneNumbers' &&
            typeof cta.value === 'object') {
            components.push((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.LeshenPhoneCTA, { ...(0, mapToPhoneNumberProps_1.default)({ data: cta.value, mappers }) }, btn.id));
        }
    }
    return components;
}
function mapToHeaderProps({ data, mappers, packages }) {
    const { logo, logoLink, borderColor, borderThickness, headerBackgroundColor, headerTextColor, navPosition, navVisibility, navBackgroundColor, navTextAlignment, navTextColor, ctaButtons, hoverTextColor, hoverBackgroundColor, navLinks, topBarNavLinks, reverseTopBar, hideLocation, topBarTextColor, topBarBackgroundColor, topBarText, textBlock, } = data;
    let headerLogo = null;
    const img = logo?.[0];
    if (img && typeof img === 'object') {
        headerLogo = mappers.mapBlock({
            block: img,
            mappers,
            inHero: true,
        });
    }
    let mappedTopBarText = [];
    if (topBarText) {
        const result = mappers.mapRichText({ richText: topBarText, mappers });
        mappedTopBarText = Array.isArray(result) ? result : [result];
    }
    let mappedTextBlock = [];
    if (textBlock) {
        const result = mappers.mapRichText({ richText: textBlock, mappers });
        mappedTextBlock = Array.isArray(result) ? result : [result];
    }
    return {
        logo: headerLogo,
        logoLink: logoLink,
        borderColor: borderColor,
        borderHeight: borderThickness,
        headerBackgroundColor: headerBackgroundColor,
        headerTextColor: headerTextColor,
        navigationPosition: navPosition === 'underLogo' ? 'Under logo' : null,
        navigationVisibility: navVisibility,
        navigationBackgroundColor: navBackgroundColor,
        callToActions: ctaButtons && mapHeaderCtaButtons(ctaButtons, mappers),
        navigationTextAlignment: navTextAlignment,
        navigationTextColor: navTextColor,
        hoverTextColor: hoverTextColor,
        hoverBackgroundColor: hoverBackgroundColor,
        navData: navLinks,
        topBarNavData: topBarNavLinks,
        reverseTopBar: reverseTopBar,
        hideLocation: hideLocation,
        textBlockAlignment: navTextAlignment,
        topBarTextColor: topBarTextColor,
        topBarBackgroundColor: topBarBackgroundColor,
        mappedTopBarText,
        textBlock: mappedTextBlock,
    };
}
exports.default = mapToHeaderProps;
